import { Injectable } from '@angular/core';
import { Http, Headers, URLSearchParams, Response, HttpModule, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ProductserialnoService {
  base_url: string;
  base_url_2: string;
  constructor(
    public http: Http,
    public http2:HttpClient
  ) {
    this.base_url = 'http://116.72.253.118:9890/invoice/GetSerialNosAccordingToGodownsJson?prodid=';
    this.base_url_2 = environment.appUrl + "/orders/stock";
  }
  
  getSerialNos(id) {
    console.log(id);
    console.log(this.base_url);
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');

    return this.http.get(this.base_url + id + "&sid=13&Qty=0", { headers: headers })
      .map(res => res.json());
  }

  getSerialNosProxyServer(oid, pid, sid): Observable<any> {
    return this.http2.get(this.base_url_2 + "/serialnumber/" + pid + "/"+ sid + "/" + oid);
  }

  getSerialNosCountProxyServer(pid): Observable<any> {
    return this.http2.get(this.base_url_2 + "/serialnumbercount/" + pid);
  }
}